// localStorage doesn't work in android web view
// since it's used for optional features such as remembering logged-in user
// we can ignore it, otherwise thrown errors might break some app functionality in that environment

export function getLocalStorageItem(key) {
  try {
    const item = localStorage.getItem(key);
    return item;
  } catch (e) {
    return null;
  }
}

export function setLocalStorageItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    // failed to set, it's okay, do nothing
  }
}

export function removeLocalStorageItem(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // failed to remove, it's okay, do nothing
  }
}
